import { I as m, j as s } from "../jsx-runtime-ClgrxkDP.js";
import { useMemo as d, createElement as f, createContext as g, useState as u, useEffect as x } from "react";
import "../crc32-LCGpXEbE.js";
import { L } from "../constants-D-_KboaS.js";
function p(t) {
  let {
    i18n: e,
    defaultNS: o,
    children: n
  } = t;
  const a = d(() => ({
    i18n: e,
    defaultNS: o
  }), [e, o]);
  return f(m.Provider, {
    value: a
  }, n);
}
const v = g(null);
function P({
  defaultLang: t,
  i18nInstance: e,
  children: o
}) {
  const [n, a] = u(t || ""), [i, l] = u(!1), c = (r) => {
    e.changeLanguage(r), a(r), localStorage.setItem(L, r);
  };
  return x(() => {
    if (e) {
      const r = e.language || t || "";
      a(r), l(!0);
    }
  }, [e, t]), !e || !i ? null : /* @__PURE__ */ s.jsx(p, { i18n: e, children: /* @__PURE__ */ s.jsx(
    v.Provider,
    {
      value: {
        currentLang: n,
        switchLanguage: c
      },
      children: o
    }
  ) });
}
export {
  v as TranslationContext,
  P as default
};
